
import { ref } from 'vue';

import { AlbumEntry } from '@/store/MusicStore';
import { getAlbumArt } from '@/util/metadataUtilities';

export default {
  setup() {
    return {
      art: ref<string>(null)
    };
  },
  props: {
    album: {
      type: Object as () => AlbumEntry,
      required: true
    }
  },
  async created() {
    this.art = await getAlbumArt(this.$props.album);
  }
};

